export const FILESTACK_PUBLIC_API_KEY = 'ABieG2cCcTSWJ6fIZVmQrz';
export const IMAGE_PLACEHOLDER = '/static/img/image-placeholder.svg';
export const MB_SIZE = 1024 * 1024;
